type Action =
  | { type: 'RESET' }
  | { type: 'NAME'; payload: string }
  | { type: 'EMAIL'; payload: string }
  | { type: 'IOS'; payload: boolean }
  | { type: 'ANDROID'; payload: boolean };

type State = {
  name: string;
  email: string;
  ios: boolean;
  android: boolean;
  isValid: boolean;
};

export const initialState: State = {
  name: '',
  email: '',
  ios: false,
  android: false,
  isValid: false,
};

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'RESET':
      return initialState;
    case 'NAME':
      return { ...state, name: action.payload };
    case 'EMAIL':
      return {
        ...state,
        email: action.payload,
        isValid: isValid(action.payload, state.ios, state.android),
      };
    case 'IOS':
      return {
        ...state,
        ios: action.payload,
        isValid: isValid(state.email, action.payload, state.android),
      };
    case 'ANDROID':
      return {
        ...state,
        android: action.payload,
        isValid: isValid(state.email, state.ios, action.payload),
      };
  }
};

const isValid = (email: string, ios: boolean, android: boolean) => {
  return email.length > 4 && (ios || android);
};
